import { CommonModule } from "@angular/common"
import { NgModule } from "@angular/core"
import { NgbModule } from "@ng-bootstrap/ng-bootstrap"
import { SharedComponentsModule } from "../shared-components/shared-components.module"
import { CollectionPremiumSubcollectionComponent } from "./collection-premium/collection-premium-subcollection/collection-premium-subcollection.component"
import { CollectionPremiumComponent } from "./collection-premium/collection-premium.component"
import { FooterLinksComponent } from "./collection-premium/footer-links/footer-links.component"
import { HeadingComponent } from "./collection-premium/heading/heading.component"
import { JumpToSectionComponent } from "./collection-premium/jump-to/jump-to-section.component"
import { MezzanineCollectionCardComponent } from "./collection-premium/mezzanine-collection-card/mezzanine-collection-card.component"
import { OverlayCollectionCardComponent } from "./collection-premium/overlay-collection-card/overlay-collection-card.component"
import { ReadMoreComponent } from "./collection-premium/read-more/read-more.component"
import { CollectionRoutingModule } from "./collection-routing.module"
import { CollectionDescriptionComponent } from "./collection-standard/collection-description/collection-description.component"
import { CollectionHeadingComponent } from "./collection-standard/collection-heading/collection-heading.component"
import { CollectionStandardComponent } from "./collection-standard/collection-standard.component"
import { InfoBarComponent } from "./collection-standard/info-bar/info-bar.component"
import { LoadMoreResourcesComponent } from "./collection-standard/load-more-resources/load-more-resources.component"
import { PaginatedResourcesComponent } from "./collection-standard/paginated-resources/paginated-resources.component"
import { ResourcesSectionComponent } from "./collection-standard/resources-section/resources-section.component"
import { CollectionBoxComponent } from "./collection-standard/sub-collection/collection-box/collection-box.component"
import { SubCollectionComponent } from "./collection-standard/sub-collection/sub-collection.component"
import { FundersComponent } from "./funders/funders.component"
import { SearchCollectionPageModule } from "./search-collection-page/search-collection-page.module"
import { WindowSizeService } from "../services/window-size.service"
import { CollectionService } from "../services/collection.service"
import { PremiumCollectionStickyNavbarComponent } from "./collection-premium/premium-collection-sticky-navbar/premium-collection-sticky-navbar.component"
import { FooterAttributionsComponent } from "./collection-premium/footer-attributions/footer-attributions.component"
import { MatButtonToggleModule } from "@angular/material/button-toggle"
import { FormsModule } from "@angular/forms"
import { CollectionPreviewGuard } from "./guards/collection-preview.guard"
import { SubCollectionPreviewGuard } from "./guards/sub-collection-preview.guard"

@NgModule({
    declarations: [
        CollectionHeadingComponent,
        FundersComponent,
        SubCollectionComponent,
        CollectionBoxComponent,
        InfoBarComponent,
        ResourcesSectionComponent,
        CollectionDescriptionComponent,
        LoadMoreResourcesComponent,
        PaginatedResourcesComponent,
        CollectionStandardComponent,
        CollectionPremiumComponent,
        ReadMoreComponent,
        JumpToSectionComponent,
        CollectionPremiumSubcollectionComponent,
        MezzanineCollectionCardComponent,
        OverlayCollectionCardComponent,
        FooterLinksComponent,
        HeadingComponent,
        PremiumCollectionStickyNavbarComponent,
        FooterAttributionsComponent,
    ],
    imports: [
        CollectionRoutingModule,
        CommonModule,
        SharedComponentsModule,
        NgbModule,
        SearchCollectionPageModule,
        MatButtonToggleModule,
        FormsModule,
    ],
    providers: [
        WindowSizeService,
        CollectionService,
        CollectionPreviewGuard,
        SubCollectionPreviewGuard,
    ],
})
export class CollectionModule {}
